import { AccountState } from '@exodus/models'
import { asset } from '@exodus/ripple-meta'

export default class RippleAccountState extends AccountState {
  static defaults = {
    balance: asset.currency.ZERO,
    sequence: 1,
    startblock: -1,
    ownerCount: 0,
    messageKey: null,
    flags: {},
  }

  // legacy
  static _tokens = [asset]
}
